export const INITIAL_ENROLL_NODE_ID = `enroll-${crypto.randomUUID()}`;

export const ADD_NODE_PLACEHOLDER_ID = 'workflow-add-node-placeholder';

export const LAYOUT = {
  enrollWidth: 320,
  gapX: 40,
};
